import LearnMore from "./LearnMore";
export default LearnMore;
